import * as React from 'react';
import Layout from './pro/layout';
import Position from './pro/position';
import Font from './pro/font';
import Border from './pro/border';
import Background from './pro/background';
import CssCode from './components/css-code';
import { StyleData } from './utils/types';
import { ConfigProvider } from '@alifd/next';
import enUS from '@alifd/next/lib/locale/en-us';
import zhCN from '@alifd/next/lib/locale/zh-cn';
import { common } from '@rchh/lowcode-engine';
import './index.less';

const { getLocale } = common.utils.createIntl?.() || {};
const locale: string = getLocale?.() || 'zh-CN';
const localeSource: any = {
  'en-US': enUS,
  'zh-CN': zhCN,
};

interface StyleSetterProps {
  value: StyleData;
  defaultValue: string;
  placeholder: string;
  field: any;
  onChange: (val: any) => void;
  isShowCssCode: boolean;
  showModuleList: string[];
}

export default class StyleSetterV2 extends React.PureComponent<StyleSetterProps> {
  static defaultProps = {
    // Default unit
    unit: 'px',
    // Default scale for computed size
    placeholderScale: 1,
    // Displayed panels
    showModuleList: ['background', 'border', 'font', 'layout', 'position'],
    // Whether to show the CSS source code editing panel
    isShowCssCode: true,
    // Layout config panel
    layoutPropsConfig: {
      // display option list
      showDisPlayList: ['inline', 'flex', 'block', 'inline-block', 'none'],
      isShowPadding: true,
      isShowMargin: true,
      isShowWidthHeight: true,
    },

    fontPropsConfig: {
      // fontFamily list
      fontFamilyList: [
        { value: 'Helvetica', label: 'Helvetica' },
        { value: 'Arial', label: 'Arial' },
        { value: 'serif', label: 'serif' },
      ],
    },

    // Position config panel
    positionPropsConfig: {
      isShowFloat: true,
      isShowClear: true,
    },
  };

  state = { styleData: {}, cssCodeVisiable: false, initFlag: false };

  componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({
        styleData: value,
      });
    }

    this.setState({
      initFlag: true,
    });
  }

  changeCssCodeVisiable = (visible: boolean) => {
    this.setState({
      cssCodeVisiable: !visible,
    });
  };

  /**
   * Style change
   * @param styleKey
   * @param value
   */
  onStyleChange = (styleDataList: StyleData[]) => {
    const { onChange } = this.props;
    const styleData: StyleData | any = Object.assign({}, this.state.styleData);
    styleDataList &&
      styleDataList.map((item) => {
        if (item.value == undefined || item.value == null) {
          delete styleData[item.styleKey];
        } else {
          styleData[item.styleKey] = item.value;
        }
      });

    this.setState({
      styleData,
    });

    onChange && onChange(styleData);
    console.log(styleData);
  };

  onStyleDataChange = (styleData: StyleData) => {
    this.setState({
      styleData,
    });
    const { onChange } = this.props;

    onChange && onChange(styleData);
  };

  render() {
    const { isShowCssCode, showModuleList } = this.props;
    const { styleData, cssCodeVisiable, initFlag } = this.state;

    return (
      <ConfigProvider locale={localeSource[locale]}>
        <div className="lowcode-setter-style-v2">
          {isShowCssCode && (
            <div className="top-bar">
              {/* <div
                onClick={() => this.changeCssCodeVisiable(false)}
                className={cssCodeVisiable ? 'top-icon-active' : 'top-icon'}
              >
                <Icon type="icon-CSS"></Icon>
              </div> */}

              <CssCode styleData={styleData} onStyleDataChange={this.onStyleDataChange} />
            </div>
          )}

          {showModuleList.filter((item) => item == 'layout').length > 0 && (
            <Layout
              onStyleChange={this.onStyleChange}
              styleData={styleData}
              {...this.props}
             />
          )}

          {showModuleList.filter((item) => item == 'font').length > 0 && (
            <Font onStyleChange={this.onStyleChange} styleData={styleData} {...this.props} />
          )}

          {showModuleList.filter((item) => item == 'background').length > 0 && (
            <Background
              onStyleChange={this.onStyleChange}
              styleData={styleData}
              {...this.props}
             />
          )}

          {showModuleList.filter((item) => item == 'position').length > 0 && (
            <Position
              onStyleChange={this.onStyleChange}
              styleData={styleData}
              {...this.props}
             />
          )}

          {showModuleList.filter((item) => item == 'border').length > 0 && (
            <Border
              onStyleChange={this.onStyleChange}
              styleData={styleData}
              {...this.props}
             />
          )}

          {/* {initFlag && (
            <CssCode
              visible={cssCodeVisiable}
              styleData={styleData}
              onStyleDataChange={this.onStyleDataChange}
              changeCssCodeVisiable={this.changeCssCodeVisiable}
            ></CssCode>
          )} */}
        </div>
      </ConfigProvider>
    );
  }
}
